import { useAuth } from '../../lib/auth-context.js'
import { SupportContact } from '../SupportContact.js'
import { SettingsSectionCard, SettingsUnavailableNotice } from './SettingsSectionCard.js'

export function SettingsAccountDeleteSection() {
  const { session } = useAuth()

  return (
    <SettingsSectionCard
      title="アカウントの完全消去"
      description="すべてのプロジェクト・ファイル・共有URL を完全に消します。元に戻せません。"
      variant="danger"
    >
      {!session ? (
        <SettingsUnavailableNotice message="アカウント登録後に利用できます。" />
      ) : (
        <div className="space-y-3">
          <p className="text-sm text-destructive/90">
            アカウントを完全に消すと、保存しているすべてのデータが削除され、復元できません。
            運営が本人確認のうえで手続きします。
          </p>
          <SupportContact
            subject="アカウント削除依頼"
            body={`削除を希望するアカウント: ${session.user.email ?? ''}\n\n上記アカウントとすべてのデータの完全消去を依頼します。`}
            label="削除を依頼する"
            className="inline-flex items-center gap-2 px-4 py-2 border border-destructive/50 text-destructive rounded-md text-sm font-medium hover:bg-destructive/10 transition-colors"
          />
        </div>
      )}
    </SettingsSectionCard>
  )
}
